/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function navbar(theme, ownerState) {
  const { palette, boxShadows, functions, transitions, breakpoints, borders } = theme;
  const { transparentNavbar, absolute, light, darkMode } = ownerState;

  const { dark, white, text, transparent, background } = palette;
  const { navbarBoxShadow } = boxShadows;
  const { rgba, pxToRem } = functions;
  const { borderRadius } = borders;

  return {
    boxShadow: transparentNavbar || absolute ? "none" : navbarBoxShadow,
    backdropFilter: transparentNavbar || absolute ? "none" : `saturate(200%) blur(${pxToRem(30)})`,
    backgroundColor:
      transparentNavbar || absolute
        ? `${transparent.main} !important`
        : rgba(darkMode ? background.default : white.main, 0.8),

    color: () => {
      let color;

      if (light) {
        color = white.main;
      } else if (transparentNavbar) {
        color = text.main;
      } else {
        color = dark.main;
      }

      return color;
    },
    top: absolute ? 0 : pxToRem(12),
    minHeight: pxToRem(15),
    display: "grid",
    alignItems: "center",
    borderRadius: borderRadius.xl,
    paddingRight: absolute ? pxToRem(8) : 0,
    paddingLeft: absolute ? pxToRem(16) : 0,

    "& > *": {
      transition: transitions.create("all", {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& .MuiToolbar-root": {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: 0,

      [breakpoints.up("sm")]: {
        minHeight: "auto",
      },
    },
  };
}

const navbarContainer = () => ({
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  px: 0,
});

const navbarRow = () => ({
  display: "flex",
  alignItems: "center",
});

const navbarIconButton = () => ({
  px: 1,

  "& .material-icons, .material-icons-round": {
    // fontSize: `${size.xl} !important`,
    fontSize: `1.8rem !important`,
  },

  "& .MuiTypography-root": {
    display: "none",

    // [breakpoints.up("sm")]: {
    //   display: "inline-block",
    //   lineHeight: 1.2,
    //   ml: 0.5,
    // },
  },
});

const navbarDesktopMenu = ({ breakpoints }) => ({
  // display: "none !important",
  cursor: "pointer",

  [breakpoints.up("xs")]: {
    display: "inline-block !important",
  },
});

const navbarMobileMenu = ({ breakpoints }) => ({
  display: "inline-block",
  lineHeight: 0,

  [breakpoints.up("xl")]: {
    display: "none",
  },
});

export {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
};
